import camelcaseKeys from 'camelcase-keys';
import { isEmpty } from 'lodash';
import { getUnitIcon } from '../../utils';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import { Clock, MapPin, Menu, Settings, Terminal, User } from 'react-feather';
import Lightbox from 'react-image-lightbox';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import {
  Badge,
  Button,
  Col,
  Label,
  Media,
  Modal,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledTooltip
} from 'reactstrap';
import Icon from 'utility/icomoon';
import AppCollapse from 'views/components/Collapse';
import TabsWrapper from 'views/components/TabsWrapper';
import DefaultButton from 'views/components/DefaultButton';
import Toolbar from 'views/components/Toolbar';
import SlidingPaneForm from 'views/formComponents/SlidingPaneForm';
import { getUnitDeviceActionParametersService } from 'views/screens/Units/services';
import Avatar from '../../../../../@core/components/avatar';
import * as alerts from '../../../../../redux/utils/alerts';
import MediaGallery from '../../../../components/MediaGallery';

import { ModalFooter } from 'react-bootstrap';
import ButtonIconDropdown from 'views/components/ButtonIconDropdown';
import DefaultSimpleButton from 'views/components/DefaultSimpleButton';
import ManualHourmeterAdjustment from 'views/formComponents/ManualHourmeterAdjustment';
import ManualOdometerAdjustment, {
  ButtonTypes
} from 'views/formComponents/ManualOdometerAdjustment';
import SlidingPaneDowntimeBinnacle from 'views/formComponents/SlidingPaneDowntimeBinnacle';
import SlidingPaneEntityTimelineBinnacle from 'views/formComponents/SlidingPaneEntityTimelineBinnacle';
import SlidingPanePreviewDriverImages from 'views/formComponents/SlidingPanePreviewDriverImages';
import SlidingPaneStartUnitDowntime from 'views/formComponents/SlidingPaneStartUnitDowntime';
import SlidingPaneUnitSpecialFunctions from 'views/formComponents/SlidingPaneUnitSpecialFunctions';
import { Metrics, searchUseMetric } from 'views/screens/Telemetry/utils';
import { GetMainStateById, GetMainStateStyle } from 'views/screens/Units/utils';
import * as authSelectors from '../../../../../redux/reducers/auth';
import * as entityTypes from '../../../Entities/constants';
import * as unitActions from '../../actions';
import useGetUnitAssets from '../../hooks/useGetUnitAssets';
import unitPermissions from '../../permissions';
import SlidingPaneVideoPlayer from '../SlidingPaneVideoPlayer';
import * as unitSelectors from '../../reducers';
import { UNIT_FETCH_INTERVAL } from '../../types';
import { getUnitActionIcon } from '../../utils';
import SlidingPaneShareUnitLocation from '../SlidingPaneShareUnitLocation';
import SlidingPaneUnitHistoricalPositionsReport from '../SlidingPaneUnitHistoricalPositionsReport';
import SlidingPaneUnitImages from '../SlidingPaneUnitImages';
import SlidingPaneUnitSendScripts from '../SlidingPaneUnitSendScripts';
import UnitFuel from '../UnitFuel';
import UnitTemperature from '../UnitTemperature';
import { env } from '@src/env';

/* -------------------------------------------------------------------------- */
/*                          SlidingPaneUnitInformation                        */
/* -------------------------------------------------------------------------- */
export default function SlidingPaneUnitInformation({
  closeSlidingPane,
  isSlidingPaneOpen,
  showHistoricalPositions,
  setMapPositionToPositionsBounds = false,
  changeSetMapPositionToUnitsBounds,
  title = '',
  selectedUnit,
  setSelectedUnit,
  selectedUnitRef,
  unitId,
  setIsTrajectoryDisable,
  isFollowUnitPositionEnabled = false,
  setIsFollowUnitPositionEnabled,
  handleRecenterMapPosition
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const style = getComputedStyle(document.body);
  const primary = env.VITE_PRIMARY_COLOR;
  const fetchInformationInterval = useRef<any>();
  const latitudeRef = useRef<any>();

  // Estado para controlar si es la primera carga de información de la unidad
  const [hasLoadedUnitData, setHasLoadedUnitData] = useState(false);
  
  // Estado para controlar el tab activo en la sección de información adicional
  const [activeInfoTab, setActiveInfoTab] = useState(1);

  const [showAddImageSlidingPane, setShowAddImageSlidingPane] = useState(false);
  const [showHistPositionsReportSlidingPane, setShowHistPositionsReportSlidingPane] =
    useState(false);
  const [downtimeBinnacleSlideOpen, openDowntimeBinnacleSlide] = useState(false);
  const [showShareUnitLocationSlidingPane, setShowShareUnitLocationSlidingPane] = useState(false);
  const [showSendScriptsSlidingPane, setShowSendScriptsSlidingPane] = useState(false);
  const [showChangeStatusSlidingPane, setShowChangeStatusPane] = useState(false);
  const [showUnitImagesSlidingPane, setShowUnitImagesSlidingPane] = useState(false);
  const [showVideoPlayerSlidingPane, setShowVideoPlayerSlidingPane] = useState(false);
  const [previewDriverImagesSlideOpen, openPreviewDriverImagesSlide] = useState(false);
  const [isOpenSlidingPaneForm, setOpenSlidingPaneForm] = useState(false);
  const [openSpecialFunctionsSlidingPane, setOpenSpecialFunctionsSlidingPane] =
    useState<boolean>(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [slidingPaneProps, setSlidingPaneProps] = useState<any>({ inputs: [] });
  const [entityBinnacleSlideOpen, openEntityBinnacleSlide] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [appMapEmbedLink, setAppMapEmbedLink] = useState<any>({
    link: '',
    title: '',
    shareWhatsAppLink: ''
  });

  const closeModal = () => {
    setIsOpenModal(false);
    setAppMapEmbedLink({ link: '', title: '', shareWhatsAppLink: '' });
  };

  const copyLocationLinkToClipboard = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      alerts.showSuccessMessage({
        success: intl.formatMessage({ id: 'common.copyLink.successMessage' })
      });
    } catch (err) {
      alerts.showErrorAlertFailChanges({
        error: { errorMessage: intl.formatMessage({ id: 'common.copyLink.failMessage' }) }
      });
    }
  };

  const {
    unit,
    isFetchingUnit,
    isFetching,
    isEditing,
    isAcknowledgeUnitEvent,
    isEditingDowntime,
    store,
    authSystems,
    userPermissions,
    user,
    parsers
  } = useSelector((state) => {
    const unit = unitSelectors.getUnit(state, unitId);
    return {
      unit: unitId
        ? {
            ...unit,
            intlLastEvent: intl.formatMessage({ id: `organizations.event${unit?.eventId ?? 0}` })
          }
        : undefined,
      isFetchingUnit: unitSelectors.isFetchingUnitById(state),
      isEditing: unitSelectors.isEditingUnit(state),
      isFetching: unitSelectors.isFetchingUnitInformation(state),
      isAcknowledgeUnitEvent: unitSelectors.isAcknowledgeUnitEvent(state),
      isEditingDowntime: unitSelectors.isEditingUnitDowntime(state),
      store: state,
      authSystems: authSelectors.getAuthSystems(state),
      userPermissions: authSelectors.getAuthUserPermissions(state),
      user: authSelectors.getAuthUser(state),
      parsers: authSelectors.getParsers(state)
    };
  });

  const { assets, isFetching: isFetchingAssets } = useGetUnitAssets(unitId);

  const permissionState = {
    ViewMetricsMonitor: 'TU001',
    showACCState: userPermissions.includes('TU002'),
    showAppVersion: userPermissions.includes('TU008'),
    showBackupBattery: userPermissions.includes('TU009'),
    showBattery: userPermissions.includes('TU010'),
    showCellNumber: userPermissions.includes('TU011'),
    showCoverTamperState: userPermissions.includes('TU012'),
    showDoorState: userPermissions.includes('TU013'),
    showGSMSignalLevel: userPermissions.includes('TU015'),
    showICCID: userPermissions.includes('TU017'),
    showIsCharging: userPermissions.includes('TU018'),
    showMainVoltage: userPermissions.includes('TU019'),
    showMCC: userPermissions.includes('TU020'),
    showMNC: userPermissions.includes('TU021'),
    showPadlockAuthorizationType: userPermissions.includes('TU023'),
    showPadlockState: userPermissions.includes('TU024'),
    showPLMN: userPermissions.includes('TU025'),
    showSatellites: userPermissions.includes('TU026'),
    showTrailerID: userPermissions.includes('TU028'),
    showDriverID: userPermissions.includes('TU029'),
    showSolarVolage: userPermissions.includes('TU030'),
    showSimInformation: userPermissions.includes('UP039'),
    showDeviceInformation: userPermissions.includes('UP040'),
    showVehicleInformation: userPermissions.includes('UP041'),
    showAssetInformation: userPermissions.includes('UP042')
  };

  const indicators = [
    {
      title: 'organizations.event2',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.Battery.BitNumber)
        ? (unit?.battery ?? '')
        : '--',
      metric: unit?.battery ? '%' : '',
      icon: 'Battery',
      field: 'Battery',
      useInActive: true,
      useInPeople: true,
      hidden:
        !permissionState.showBattery ||
        !searchUseMetric(unit?.metricsMask, Metrics.Battery.BitNumber)
    },
    {
      title: 'metric.mainVoltage',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.MainVoltage.BitNumber)
        ? (unit?.mainVoltage ?? '')
        : '--',
      metric: 'volt',
      icon: 'Lightning',
      sizeIcon: 30,
      field: 'MainVoltage',
      useInVehicles: true,
      hidden:
        !permissionState.showMainVoltage ||
        !searchUseMetric(unit?.metricsMask, Metrics.MainVoltage.BitNumber)
    },
    {
      title: 'metric.isCharging',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.IsCharging.BitNumber)
        ? intl.formatMessage({
            id:
              unit?.isCharging === 2
                ? 'trackingUnits.charging.solar'
                : unit?.isCharging
                  ? 'trackingUnits.charging.yes'
                  : 'trackingUnits.charging.no'
          })
        : '--',
      metric: '',
      icon: 'Alert-350',
      field: 'IsCharging',
      customChartTooltip: 'bool',
      useInActive: true,
      isSelectable: false,
      hidden:
        !permissionState.showIsCharging ||
        !searchUseMetric(unit?.metricsMask, Metrics.IsCharging.BitNumber)
    },
    {
      title: 'metric.solarVoltage',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.SolarVoltage.BitNumber)
        ? (unit?.solarVoltage ?? '')
        : '--',
      metric: 'volt',
      icon: 'sun',
      sizeIcon: 30,
      field: 'SolarVoltage',
      useInActive: true,
      useInVehicles: false,
      hidden:
        !permissionState.showSolarVolage ||
        !searchUseMetric(unit?.metricsMask, Metrics.SolarVoltage.BitNumber)
    },
    {
      title: 'metric.BB',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.BackupBattery.BitNumber)
        ? (unit?.backupBattery ?? '')
        : '--',
      metric: unit?.backupBattery ? 'volt' : '',
      icon: 'backupEnergy',
      field: 'BackupBattery',
      useInActive: true,
      useInVehicles: true,
      hidden:
        !permissionState.showBackupBattery ||
        !searchUseMetric(unit?.metricsMask, Metrics.BackupBattery.BitNumber)
    },
    {
      title: 'metric.DS',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.DoorState.BitNumber)
        ? intl.formatMessage({ id: unit?.doorState ? 'common.yes' : 'common.no' })
        : '--',
      metric: '',
      icon: 'OpenDoor',
      field: 'DoorState',
      useInActive: true,
      useInVehicles: true,
      isSelectable: false,
      hidden:
        !permissionState.showDoorState ||
        !searchUseMetric(unit?.metricsMask, Metrics.DoorState.BitNumber)
    },
    {
      title: 'metric.CTS',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.CoverTamperState.BitNumber)
        ? intl.formatMessage({
            id: unit?.coverTamperState ? 'common.yes' : 'common.no'
          })
        : '--',
      metric: '',
      field: 'CoverTamperState',
      useInActive: true,
      isSelectable: false,
      hidden:
        !permissionState.showCoverTamperState ||
        !searchUseMetric(unit?.metricsMask, Metrics.CoverTamperState.BitNumber)
    },
    {
      title: 'metric.PLS',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.PadlockState.BitNumber)
        ? intl.formatMessage({
            id: unit?.padlockState ? 'trackingUnits.sat.open' : 'trackingUnits.sat.closed'
          })
        : '--',
      metric: '',
      field: 'PadlockState',
      useInActive: true,
      isSelectable: false,
      hidden:
        !permissionState.showPadlockState ||
        !searchUseMetric(unit?.metricsMask, Metrics.PadlockState.BitNumber)
    },
    {
      title: 'metric.PLA',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.PadlockAuthorizationType.BitNumber)
        ? intl.formatMessage({
            id: unit?.padlockAuthorizationType ? 'common.yes' : 'common.no'
          })
        : '--',
      metric: '',
      field: 'PadlockAuthorizationType',
      useInActive: true,
      isSelectable: false,
      hidden:
        !permissionState.showPadlockAuthorizationType ||
        !searchUseMetric(unit?.metricsMask, Metrics.PadlockAuthorizationType.BitNumber)
    },
    {
      title: 'metric.SAT',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.Satellites.BitNumber)
        ? (unit?.satellites ?? '')
        : '--',
      metric: '',
      icon: 'satellite',
      field: 'Satellites',
      useInActive: true,
      useInVehicles: true,
      linealChart: true,
      hidden:
        !permissionState.showSatellites ||
        !searchUseMetric(unit?.metricsMask, Metrics.Satellites.BitNumber)
    },
    {
      title: 'metric.gsmSignalLevel',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.GSMSignalLevel.BitNumber)
        ? (unit?.gsmSignalLevel ?? '')
        : '--',
      metric: '',
      field: 'gsmSignalLevel',
      useInActive: true,
      useInVehicles: true,
      hidden:
        !unit?.gsmSignalLevel ||
        !permissionState.showGSMSignalLevel ||
        !searchUseMetric(unit.metricsMask, Metrics.GSMSignalLevel.BitNumber)
    },
    {
      title: 'metric.abrev.plmn',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.PLMN.BitNumber)
        ? (unit?.plmn ?? '')
        : '--',
      metric: '',
      field: 'PLMN',
      useInActive: true,
      useInVehicles: true,
      hidden:
        !unit?.plmn ||
        !permissionState.showPLMN ||
        !searchUseMetric(unit.metricsMask, Metrics.PLMN.BitNumber)
    },
    {
      title: 'metric.abrev.mcc',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.MCC.BitNumber)
        ? (unit?.mcc ?? '')
        : '--',
      metric: '',
      field: 'MCC',
      useInActive: true,
      useInVehicles: true,
      isSelectable: false,
      hidden: !permissionState.showMCC || !searchUseMetric(unit?.metricsMask, Metrics.MCC.BitNumber)
    },
    {
      title: 'metric.abrev.mnc',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.MNC.BitNumber)
        ? (unit?.mnc ?? '')
        : '--',
      metric: '',
      field: 'MNC',
      useInActive: true,
      useInVehicles: true,
      isSelectable: false,
      hidden:
        !unit?.mnc ||
        !permissionState.showMNC ||
        !searchUseMetric(unit.metricsMask, Metrics.MNC.BitNumber)
    },
    {
      title: 'metric.CN',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.CellNumber.BitNumber)
        ? (unit?.cellNumber ?? '')
        : '--',
      metric: '',
      icon: 'cellular-signal',
      field: 'CellNumber',
      useInActive: true,
      useInVehicles: true,
      hidden:
        !permissionState.showCellNumber ||
        !searchUseMetric(unit?.metricsMask, Metrics.CellNumber.BitNumber)
    },
    {
      title: 'metric.abrev.ICC',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.ICCID.BitNumber)
        ? (unit?.iccid ?? '')
        : '--',
      metric: '',
      field: 'ICCID',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      hidden:
        !unit?.iccid ||
        !permissionState.showICCID ||
        !searchUseMetric(unit?.metricsMask, Metrics.ICCID.BitNumber)
    },
    /* indicadores de vehiculos */
    {
      title: 'metric.DI',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.DriverId.BitNumber)
        ? (unit?.driverId ?? '')
        : '--',
      metric: '',
      field: 'DriverId',
      isSelectable: false,
      useInActive: false,
      useInVehicles: true,
      hidden:
        !unit?.driverId ||
        !permissionState.showDriverID ||
        !searchUseMetric(unit?.metricsMask, Metrics.DriverId.BitNumber)
    },
    {
      title: 'metric.TID',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.TrailerID.BitNumber)
        ? (unit?.trailerId ?? '')
        : '--',
      metric: '',
      field: 'TrailerId',
      isSelectable: false,
      useInActive: false,
      useInVehicles: true,
      hidden:
        !unit?.trailerId ||
        !permissionState.showTrailerID ||
        !searchUseMetric(unit?.metricsMask, Metrics.TrailerID.BitNumber)
    },
    {
      title: 'AppVersion',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.AppVersion.BitNumber)
        ? (unit?.appVersion ?? '')
        : '--',
      metric: '',
      field: 'AppVersion',
      isSelectable: false,
      useInPeople: true,
      hidden:
        !permissionState.showAppVersion ||
        !searchUseMetric(unit?.metricsMask, Metrics.AppVersion.BitNumber)
    },
    {
      title: 'metric.locationAlways',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.LocationAlways.BitNumber)
        ? intl.formatMessage({ id: unit?.locationAlways ? 'common.yes' : 'common.no' })
        : '--',
      metric: '',
      field: 'LocationAlways',
      icon: 'User',
      isSelectable: false,
      useInPeople: true,
      hidden: !searchUseMetric(unit?.metricsMask, Metrics.LocationAlways.BitNumber),
      useInAppCollapse: true,
      informationType: 'PERMISSIONS'
    },
    {
      title: 'metric.locationWhenInUse',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.LocationWhenInUse.BitNumber)
        ? intl.formatMessage({ id: unit?.locationWhenInUse ? 'common.yes' : 'common.no' })
        : '--',
      metric: '',
      field: 'LocationWhenInUse',
      icon: 'User',
      isSelectable: false,
      useInPeople: true,
      hidden: !searchUseMetric(unit?.metricsMask, Metrics.LocationWhenInUse.BitNumber),
      useInAppCollapse: true,
      informationType: 'PERMISSIONS'
    },
    {
      title: 'metric.ignoreBatteryOptimizations',
      currentStatus: searchUseMetric(
        unit?.metricsMask,
        Metrics.IgnoreBatteryOptimizations.BitNumber
      )
        ? intl.formatMessage({ id: unit?.ignoreBatteryOptimizations ? 'common.yes' : 'common.no' })
        : '--',
      metric: '',
      field: 'IgnoreBatteryOptimizations',
      icon: 'User',
      isSelectable: false,
      useInPeople: true,
      hidden: !searchUseMetric(unit?.metricsMask, Metrics.IgnoreBatteryOptimizations.BitNumber),
      useInAppCollapse: true,
      informationType: 'PERMISSIONS'
    },
    {
      title: 'metric.activityRecognition',
      currentStatus: searchUseMetric(unit?.metricsMask, Metrics.ActivityRecognition.BitNumber)
        ? intl.formatMessage({ id: unit?.activityRecognition ? 'common.yes' : 'common.no' })
        : '--',
      metric: '',
      field: 'ActivityRecognition',
      icon: 'User',
      isSelectable: false,
      useInPeople: true,
      hidden: !searchUseMetric(unit?.metricsMask, Metrics.ActivityRecognition.BitNumber),
      useInAppCollapse: true,
      informationType: 'PERMISSIONS'
    },
    {
      title: 'common.id',
      currentStatus: !unit?.simCardId ? 'N/A' : unit?.simCardId,
      metric: '',
      field: 'simId',
      icon: 'Phone',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showSimInformation,
      useInAppCollapse: true,
      informationType: 'SIM'
    },
    {
      title: 'sims.cellularNumber',
      currentStatus: !unit?.simCellularNumber ? 'N/A' : unit?.simCellularNumber,
      metric: '',
      field: 'simCellularNumber',
      icon: 'Phone',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showSimInformation,
      useInAppCollapse: true,
      informationType: 'SIM'
    },
    {
      title: 'sims.cellularProvider',
      currentStatus: !unit?.cellularProviderName ? 'N/A' : unit?.cellularProviderName,
      metric: '',
      field: 'simcellularProvider',
      icon: 'Phone',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showSimInformation,
      useInAppCollapse: true,
      informationType: 'SIM'
    },
    {
      title: 'sims.iccid',
      currentStatus: !unit?.iccid ? 'N/A' : unit?.iccid,
      metric: '',
      field: 'simIccid',
      icon: 'Phone',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showSimInformation,
      useInAppCollapse: true,
      informationType: 'SIM'
    },
    {
      title: 'sims.imsi',
      currentStatus: !unit?.imsi ? 'N/A' : unit?.imsi,
      metric: '',
      field: 'simImsi',
      icon: 'Phone',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showSimInformation,
      useInAppCollapse: true,
      informationType: 'SIM'
    },
    {
      title: 'common.id',
      currentStatus: !unit?.deviceId ? 'N/A' : unit?.deviceId,
      metric: '',
      field: 'deviceId',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'trackingUnits.deviceUniqueIdentifier',
      currentStatus: !unit?.deviceIdentifier ? 'N/A' : unit?.deviceIdentifier,
      metric: '',
      field: 'deviceIdentifier',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInActive: true,
      useInVehicles: true,
      useInPeople: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'trackingUnits.gpsBrand',
      currentStatus: !unit?.brandName ? 'N/A' : unit?.brandName,
      metric: '',
      field: 'gpsBrand',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInPeople: true,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'trackingUnits.gpsModel',
      currentStatus: !unit?.deviceModelName ? 'N/A' : unit?.deviceModelName,
      metric: '',
      field: 'deviceModelName',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInPeople: true,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'modules.serialNumber',
      currentStatus: !unit?.serialNumber ? 'N/A' : unit?.serialNumber,
      metric: '',
      field: 'deviceSerialNumber',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInPeople: true,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'modules.imei',
      currentStatus: !unit?.deviceImei ? 'N/A' : unit?.deviceImei,
      metric: '',
      field: 'deviceImei',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInPeople: true,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'modules.propertyTypeId',
      currentStatus: !unit?.devicePropertyTypeId
        ? 'N/A'
        : intl.formatMessage({ id: `trackingUnits.propertyType${unit?.devicePropertyTypeId}` }),
      metric: '',
      field: 'devicePropertyTypeId',
      icon: 'noun_GPS_3452904',
      isSelectable: false,
      useInPeople: true,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showDeviceInformation,
      useInAppCollapse: true,
      informationType: 'DEVICE'
    },
    {
      title: 'common.id',
      currentStatus: !unit?.vehicleId ? 'N/A' : unit?.vehicleId,
      metric: '',
      field: 'vehicleId',
      icon: 'noun_Wheel_4039720',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'trackingUnits.vehicleName',
      currentStatus: !unit?.vehicleName ? 'N/A' : unit?.vehicleName,
      metric: '',
      field: 'vehicleName',
      icon: 'noun_Wheel_4039720',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'vehicles.maker',
      currentStatus: !unit?.vehicleMakerName ? 'N/A' : unit?.vehicleMakerName,
      metric: '',
      field: 'vehicleMakerName',
      icon: 'noun_Wheel_4039720',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'vehicles.model',
      currentStatus: !unit?.vehicleModelName ? 'N/A' : unit?.vehicleModelName,
      metric: '',
      field: 'vehicleModelName',
      icon: 'noun_Wheel_4039720',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'vehicles.licensePlate',
      currentStatus: !unit?.licensePlate ? 'N/A' : unit?.licensePlate,
      metric: '',
      field: 'licensePlate',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'vehicles.chasis',
      currentStatus: !unit?.chasis ? 'N/A' : unit?.chasis,
      metric: '',
      field: 'chasis',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'vehicles.motor',
      currentStatus: !unit?.motor ? 'N/A' : unit?.motor,
      metric: '',
      field: 'motor',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showVehicleInformation || !unit?.motor,
      useInAppCollapse: true,
      informationType: 'VEHICLE'
    },
    {
      title: 'trackingUnits.assetName',
      currentStatus: !unit?.assetIdentifier ? 'N/A' : unit?.assetIdentifier,
      metric: '',
      field: 'assetIdentifier',
      isSelectable: false,
      useInPeople: false,
      useInActive: true,
      useInVehicles: true,
      hidden: !permissionState.showAssetInformation,
      useInAppCollapse: true,
      informationType: 'ASSET'
    }
  ];

  const availableIndicators =
    unit?.unitTypeId === 2
      ? indicators.filter((indicator) => !indicator?.hidden && indicator.useInActive === true)
      : unit?.unitTypeId === 1
        ? indicators.filter((indicator) => !indicator?.hidden && indicator.useInVehicles === true)
        : unit?.unitTypeId === 0
          ? indicators.filter((indicator) => !indicator?.hidden && indicator.useInPeople === true)
          : [];

  const unitIndicators = availableIndicators.filter(
    (indicator) => indicator?.useInAppCollapse === true
  );

  const unitAssetInformation =
    permissionState.showAssetInformation && unit?.unitTypeId !== 0
      ? assets
          .filter((asset) => asset.assetTypeId !== 1) // Filtra los activos de tipo vehiculo
          .map((asset) => {
            return {
              assetIdentifier: !asset?.assetIdentifier ? 'N/A' : asset?.assetIdentifier,
              assetData: [
                {
                  title: 'common.id',
                  currentStatus: !asset?.assetId ? 'N/A' : asset?.assetId,
                  metric: '',
                  field: 'assetId'
                },
                {
                  title: 'assets.assetType',
                  currentStatus: !asset?.assetTypeId
                    ? 'N/A'
                    : intl.formatMessage({ id: `assets.assetTypes${asset.assetTypeId}` }),
                  metric: '',
                  field: 'assetType'
                }
              ]
            };
          })
      : [];

  //activar el interval de actualizacion de la informacion del unidad
  useEffect(() => {
    fetchInformationInterval.current = setInterval(() => {
      if (unit?.unitId) {
        dispatch(unitActions.startFetchingUnitInformation(unit?.unitId));
      }
    }, UNIT_FETCH_INTERVAL);

    // Limpiar el intervalo al desmontar el componente
    return () => {
      if (fetchInformationInterval.current) clearInterval(fetchInformationInterval.current);
    };
  }, []);

  useEffect(() => {
    if (
      !isEditing &&
      !isFetching &&
      !isFetchingUnit &&
      isSlidingPaneOpen &&
      unit?.unitId &&
      !isEditingDowntime
    )
      dispatch(unitActions.startFetchingUnitInformation(unit?.unitId));
  }, [isEditing, isSlidingPaneOpen, unit?.unitId, isEditingDowntime]);

  // Efecto para controlar el estado de loading inicial
  useEffect(() => {
    // Si tenemos datos de la unidad y aún no hemos marcado como cargados
    if (unit && !hasLoadedUnitData && !isFetchingUnit) {
      setHasLoadedUnitData(true);
    }
    // Si cambia el unitId, resetear el estado de carga para la nueva unidad
    if (unitId && !unit) {
      setHasLoadedUnitData(false);
    }
  }, [unit, isFetchingUnit, hasLoadedUnitData, unitId]);

  const [followPositionButtonState, setFollowPositionButtonState] = useState<boolean>(false);

  useEffect(() => {
    if (setIsFollowUnitPositionEnabled) {
      if (showHistPositionsReportSlidingPane && isFollowUnitPositionEnabled) {
        setFollowPositionButtonState(true);
        setIsFollowUnitPositionEnabled(false);
      } else if (!showHistPositionsReportSlidingPane && followPositionButtonState) {
        setIsFollowUnitPositionEnabled(true);
      }
    }
  }, [showHistPositionsReportSlidingPane]);

  const copyLatLong = (latitude, longitude) => {
    navigator.clipboard.writeText(`${latitude.toFixed(6)},${longitude.toFixed(6)}`);

    alerts.showSuccessMessage({
      success: intl.formatMessage({ id: 'common.copyClipboardSuccessfully' })
    });
  };

  const doAction = (unit, action) => {
    if (action.requireUserConfirmation) {
      alerts.showConfirmationMessage({
        message: intl.formatMessage(
          { id: 'units.userConfirmationMessage' },
          {
            unit: unit.unitName,
            action: intl.formatMessage({
              id: 'units.deviceActionId.' + action.deviceActionId
            })
          }
        ),
        action() {
          dispatch(unitActions.executeDeviceAction(unit.unitId, action.deviceActionId));
        }
      });
    } else {
      if (action.requireParameters) {
        getUnitDeviceActionParametersService({
          unitId: unit.unitId,
          deviceActionId: action.deviceActionId
        }).then((response) => {
          if (response.success) {
            setSlidingPaneProps({
              title: intl.formatMessage({
                id: 'units.deviceActionId.' + action.deviceActionId
              }),
              width: '40rem',
              inputs: response.data.map((result) => {
                const param = camelcaseKeys(result);
                return {
                  type: param.inputType,
                  name: 'input-' + param.deviceActionParameterId,
                  initialValue: param.inputValue,
                  required: param.isRequired,
                  label: param.parameterName,
                  placeholder: param.parameterComments,
                  appendcomponent: param.measurementUnitName,
                  min: param.minValue != null ? param.minValue : undefined,
                  max: param.maxValue != null ? param.maxValue : undefined
                };
              }),
              action: (values) =>
                dispatch(
                  unitActions.executeDeviceAction(
                    unit.unitId,
                    action.deviceActionId,
                    response.data
                      .map((result) => {
                        const param = camelcaseKeys(result);
                        return (
                          param.deviceActionParameterId +
                          '~' +
                          values['input-' + param.deviceActionParameterId]
                        );
                      })
                      .join('^')
                  )
                )
            });
            setOpenSlidingPaneForm(true);
          }
        });
      } else dispatch(unitActions.executeDeviceAction(unit.unitId, action.deviceActionId));
    }
  };

  return (
    <>
      <SlidingPane
        className="custom-sliding-pane pt-0"
        overlayClassName={'custom-overlay-sliding-pane-map'}
        isOpen={isSlidingPaneOpen}
        title={
          <>
            {unit?.unitName ? unit.unitName : title}
            {userPermissions.includes('UP043') && (
              <Icon
                id={'editUnitName'}
                icon={'Edit2'}
                color={primary}
                size={18}
                style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                onClick={() => {
                  setSlidingPaneProps({
                    title: intl.formatMessage({ id: 'common.edit' }),
                    subtitle: `${intl.formatMessage({ id: 'units.unit' })}: ${title}`,
                    width: '45rem',
                    inputs: [
                      {
                        type: 'text',
                        name: 'unitName',
                        required: true,
                        initialValue: unit?.unitName,
                        label: intl.formatMessage({ id: 'units.unit.name' })
                      },
                      {
                        type: 'text',
                        name: 'alias',
                        required: false,
                        initialValue: unit?.alias,
                        label: intl.formatMessage({ id: 'common.alias' })
                      },
                      {
                        type: 'unitThemeDropdown',
                        name: 'themeId',
                        required: true,
                        initialValue: unit?.themeId,
                        id: 'unitThemeDropdown'
                      }
                    ],
                    action: (values) => {
                      dispatch(
                        unitActions.startEditingUnit({
                          ...unit,
                          unitName: values.unitName,
                          alias: values.alias,
                          themeId: values.themeId
                        })
                      );
                    }
                  });
                  setOpenSlidingPaneForm(true);
                }}
              />
            )}
          </>
        }
        width="45rem"
        onRequestClose={closeSlidingPane}
      >
        {/* Loading inicial solo para la primera carga */}
        {!hasLoadedUnitData && isFetchingUnit && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <div className="text-center">
              <Spinner color="primary" />
              <div className="mt-2">
                <Label className="text-muted">
                  {intl.formatMessage({ id: 'common.loading' })}...
                </Label>
              </div>
            </div>
          </div>
        )}

        {/* Contenido principal - solo se muestra si ya se cargó la información inicial */}
        {(hasLoadedUnitData || !isFetchingUnit) && (
          <>
            {(unit?.images?.length ?? 0) > 0 && (
              <MediaGallery
                height={'20%'}
                heightThumbs={'5%'}
                isRtl={false}
                images={
                  unit?.images?.map((image) => ({
                    ...image,
                    fullImageUrl: image?.imageUrl,
                    imageDescription: image?.imageDescription || '',
                    imageType: image?.imageTypeId || 0,
                    imagePath: image?.imagePath || image?.imageUrl || ''
                  })) ?? []
                }
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                navigation={true}
                pagination={true}
                className={'default-width-image'}
                classNameImg={'img-contain-nowidth'}
              />
            )}
            {/* Toolbar for unit information */}
            {unit?.latitude != null && unit?.longitude != null && (
              <>
                <Row>
                  <Col sm="2" className="d-flex mb-0 align-items-center">
                    <div className={'d-flex'}>
                      <Label className="label-information">
                        {intl.formatMessage({ id: 'units.id' })}:
                      </Label>
                      <Label className="ml-2 label-value-information">{unit.unitId}</Label>
                    </div>
                  </Col>
                  <Col sm="10">
                    <Toolbar
                      className={'mb-0'}
                      buttons={[
                        <ButtonIconDropdown
                          key={'UnitActionsOptionsDropdown'}
                          id={'buttonToolbarOptions'}
                          color={'secondary'}
                          tooltipPlacement={'left'}
                          onlyIconDropDown
                          buttonIcons={[
                            {
                              key: 1,
                              id: 'openTrackUnitWindow',
                              icon: 'Monitor',
                              action: () => {
                                localStorage.setItem('disableShowUnitsLocalStorage', 'true');
                                window.open(
                                  `/track/${unitId}/${unit?.latitude}/${unit?.longitude}`,
                                  '_blank',
                                  'width=800,height=600,top=100,left=100,resizable=yes,scrollbars=yes'
                                );
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'trackingUnits.map.trackUnitNewWindow'
                              })
                            },
                            {
                              key: 2,
                              id: 'unitImagesButton',
                              icon: 'Image',
                              action: () => {
                                setShowAddImageSlidingPane(false);
                                setShowUnitImagesSlidingPane(true);
                              },
                              tooltipMessage: intl.formatMessage({ id: 'units.editImages' })
                            },
                            {
                              key: 3,
                              id: 'unitImagesAddButton',
                              icon: 'Upload',
                              action: () => {
                                setShowAddImageSlidingPane(true);
                                setShowUnitImagesSlidingPane(true);
                              },
                              tooltipMessage: intl.formatMessage({ id: 'units.addImage' })
                            },
                            {
                              key: 4,
                              id: 'sendScriptsButton',
                              icon: 'ScriptCode',
                              action: () => {
                                setShowSendScriptsSlidingPane(true);
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'units.sendScripts'
                              }),
                              permissions: [unitPermissions.sendScripts]
                            },
                            {
                              key: 5,
                              id: 'unitSpecialFuntion',
                              icon: 'GearsTurning',
                              action: () => {
                                setOpenSpecialFunctionsSlidingPane(true);
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'buttons.specialFunctions'
                              }),
                              permissions: ['UF001']
                            },
                            {
                              key: 6,
                              id: 'binnacleButton',
                              icon: 'Planning',
                              action: () => {
                                openEntityBinnacleSlide(true);
                              },
                              tooltipMessage: intl?.formatMessage({ id: 'trackingUnits.binnacle' })
                            },
                            {
                              key: 7,
                              id: 'binnacleDowntimeButton',
                              icon: 'Planning',
                              action: () => {
                                openDowntimeBinnacleSlide(true);
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'trackingUnits.downtimeBinnacle'
                              }),
                              permissions: [unitPermissions.downtime]
                            }
                          ]}
                        />,
                        <DefaultButton
                          id={'followUnitPositionButton'}
                          color={isFollowUnitPositionEnabled ? 'success' : 'secondary'}
                          icon={isFollowUnitPositionEnabled ? 'ToggleRight' : 'ToggleLeft'}
                          handleClick={() => {
                            if (setIsFollowUnitPositionEnabled)
                              setIsFollowUnitPositionEnabled(!isFollowUnitPositionEnabled);
                          }}
                          tooltipMessage={
                            isFollowUnitPositionEnabled
                              ? intl.formatMessage({ id: 'units.disableFollowUnitPosition' })
                              : intl.formatMessage({ id: 'units.enableFollowUnitPosition' })
                          }
                          tooltipPosition="top"
                        />,
                        <DefaultButton
                          id={'recenterUnitPosition'}
                          color={'info'}
                          icon={'Crosshair'}
                          iconSize={18}
                          handleClick={() => {
                            handleRecenterMapPosition([unit?.latitude, unit?.longitude]);
                          }}
                          tooltipMessage={intl.formatMessage({
                            id: 'units.centerMapToUnit'
                          })}
                          tooltipPosition="top"
                        />,
                        ...(unit?.videoStreaming
                          ? [
                              <DefaultButton
                                id={'videoPlayerButton'}
                                color={'secondary'}
                                icon={'Video'}
                                handleClick={() => {
                                  setShowVideoPlayerSlidingPane(true);
                                }}
                                tooltipMessage={intl.formatMessage({
                                  id: 'units.videoPlayer'
                                })}
                                tooltipPosition="top"
                              />
                            ]
                          : []),
                        <ButtonIconDropdown
                          key={'shareOptionsDropdown'}
                          id={'shareLocationUnitOptions'}
                          color={'secondary'}
                          iconFixed={'Share2'}
                          tooltipMessage={intl.formatMessage({ id: 'units.shareLocation' })}
                          onlyIconDropDown
                          buttonIcons={[
                            {
                              key: 1,
                              id: 'wazeLocation',
                              icon: 'waze',
                              action: () => {
                                const wazeLink = `https://embed.waze.com/iframe?zoom=14&lat=${unit?.latitude}&lon=${unit?.longitude}&pin=1&ct=livemap`;
                                const whatsappLink = `https://wa.me/?text=${encodeURIComponent(
                                  `¡Sigue la ubicación en Waze! ${wazeLink}`
                                )}`;
                                setAppMapEmbedLink({
                                  link: wazeLink,
                                  title: intl.formatMessage({ id: 'common.wazeLocation' }),
                                  shareWhatsAppLink: whatsappLink
                                });
                                setIsOpenModal(true);
                                copyLocationLinkToClipboard(wazeLink);
                                alerts.showSuccessMessage({
                                  success: intl.formatMessage({
                                    id: 'locations.shareLocation.copyClipboardSuccess',
                                    defaultMessage:
                                      'El enlace de ubicación fue copiado al portapapeles.'
                                  })
                                });
                              },
                              tooltipMessage: intl.formatMessage({ id: 'units.shareLocation.waze' })
                            },
                            {
                              key: 2,
                              id: 'googleMapsLocation',
                              icon: 'Google1',
                              action: () => {
                                const googleMapsLink = `https://www.google.com/maps?q=${unit?.latitude},${unit?.longitude}`;
                                const whatsappLink = `https://wa.me/?text=${encodeURIComponent(
                                  `¡Sigue la ubicación en Google Maps! ${googleMapsLink}`
                                )}`;
                                if (user.useGoogleMaps === 1) {
                                  setAppMapEmbedLink({
                                    link: `https://www.google.com/maps/embed/v1/place?key=${user.googleMapsApiKey}&q=${unit?.latitude},${unit?.longitude}&zoom=16`,
                                    title: intl.formatMessage({ id: 'common.googleMapLocation' }),
                                    shareWhatsAppLink: whatsappLink
                                  });
                                  setIsOpenModal(true);
                                  copyLocationLinkToClipboard(googleMapsLink);
                                } else copyLocationLinkToClipboard(googleMapsLink);

                                alerts.showSuccessMessage({
                                  success: intl.formatMessage({
                                    id: 'locations.shareLocation.copyClipboardSuccess',
                                    defaultMessage:
                                      'El enlace de ubicación fue copiado al portapapeles.'
                                  })
                                });
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'units.shareLocation.googleMaps'
                              })
                            },
                            {
                              key: 3,
                              id: 'shareUnitLocationWhatsApp',
                              icon: 'whatsapp',
                              action: () => {
                                const wazeLink = `https://www.waze.com/ul?ll=${unit?.latitude},${unit?.longitude}&navigate=yes`;
                                const whatsappLink = `https://wa.me/?text=${encodeURIComponent(
                                  `¡Sigue la ubicación en Waze! ${wazeLink}`
                                )}`;

                                // Redirige a WhatsApp para compartir el enlace
                                window.open(whatsappLink, '_blank');
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'units.shareLocation.whatsapp'
                              })
                            },
                            {
                              key: 4,
                              id: 'webtrackLink',
                              icon: 'Link',
                              action: () => {
                                setShowShareUnitLocationSlidingPane(true);
                              },
                              tooltipMessage: intl.formatMessage({
                                id: 'units.shareLocation.webtrack'
                              })
                            }
                          ]}
                        />,
                        <DefaultButton
                          id={'historicalPositionsButton'}
                          icon={'history'}
                          color="primary"
                          isDisabled={false}
                          handleClick={() => {
                            setShowHistPositionsReportSlidingPane(true);
                            if (setIsTrajectoryDisable) setIsTrajectoryDisable(true);
                          }}
                          tooltipMessage={intl.formatMessage({
                            id: 'units.showHistoricalPositionsReport'
                          })}
                          tooltipPosition="top"
                          permissions={['UR001']}
                        />
                      ]}
                    />
                  </Col>
                </Row>{' '}
                {/* Tabs de información */}
                <hr className={'full-width-slide-panel'} />
                <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
                  <TabsWrapper
                    vertical={false}
                    initialActiveTab={1}
                    activeTab={activeInfoTab}
                    setActiveTab={setActiveInfoTab}
                    useCardContent={false}
                    tabs={[
                      {
                        icon: getUnitIcon(unit?.themeId ?? 1),
                        title: '',
                        tooltip: 'common.information',
                        tabId: 1,
                        iconSize: 18
                      },
                      unit?.organizationId && {
                        icon: 'Afiliaciones',
                        title: '',
                        tooltip: 'sidebar.affiliations',
                        tabId: 9,
                        iconSize: 18
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 3)?.length ?? 0) > 0 && {
                        icon: 'Thermometer',
                        title: '',
                        tooltip: 'units.temperatureSensors',
                        tabId: 2,
                        iconSize: 18
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 8)?.length ?? 0) > 0 && {
                        icon: 'GasStation',
                        title: '',
                        tooltip: 'units.gasolineSensors',
                        tabId: 3,
                        iconSize: 18
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 16)?.length ?? 0) > 0 && {
                        icon: 'Activity',
                        title: '',
                        tooltip: 'units.pressureSensors',
                        tabId: 4,
                        iconSize: 18
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'SIM')?.length ?? 0) > 0 && {
                        icon: 'Phone',
                        title: '',
                        tooltip: 'sims.sim',
                        tabId: 5,
                        iconSize: 18
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'DEVICE')?.length ?? 0) > 0 && {
                        icon: 'Send',
                        title: '',
                        tooltip: 'modules.module',
                        tabId: 6,
                        iconSize: 18
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'VEHICLE')?.length ?? 0) > 0 && {
                        icon: 'noun_Wheel_4039720',
                        title: '',
                        tooltip: 'vehicles.vehicle',
                        tabId: 7,
                        iconSize: 22
                      },
                      (unitAssetInformation?.length ?? 0) > 0 && {
                        icon: 'Alert-76',
                        title: '',
                        tooltip: unitAssetInformation?.length === 1 ? 'assets.asset' : 'assets.assets',
                        tabId: 8,
                        iconSize: 24
                      }
                    ].filter((tab) => tab)}
                    tabsContent={[
                      {
                        tabId: 1,
                        component: (
                          <div className={'pt-1'}>
                {unit?.driverId && (
                  <>
                    <Label className="label-information">
                      <User color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.driver' })}
                    </Label>
                    <Media className={'align-items-center'}>
                      <Avatar
                        // @ts-ignore unreachable error
                        img={unit?.driverPhoto ? unit?.driverPhoto : undefined}
                        color="light-primary"
                        className={'mr-1'}
                        content={unit.driverName ?? ''}
                        initials
                        onClick={() => setIsLightboxOpen(true)}
                      />
                      <div>
                        <Label className="label-value-information">
                          {!isEmpty(unit.driverName) ? unit.driverName : 'N/A'}
                        </Label>
                        {unit?.driverPhoneNumber &&
                          `${intl.formatMessage({ id: 'units.phone' })}: ${
                            unit?.driverPhoneNumber
                          }`}
                      </div>
                      <div>
                        {(unit?.driverTotalFiles ?? 0) > 0 && (
                          <>
                            <UncontrolledTooltip target={'driverAttachedImagesButton'}>
                              {intl.formatMessage({ id: 'drivers.seeAttachedImages' })}
                            </UncontrolledTooltip>
                            <Icon
                              id={'driverAttachedImagesButton'}
                              icon={'Image'}
                              color={primary}
                              size={18}
                              style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                              onClick={() => openPreviewDriverImagesSlide(true)}
                            />
                          </>
                        )}
                      </div>
                    </Media>
                    <hr className={'full-width-slide-panel'} />
                  </>
                )}
                <Label className="label-information">
                  <MapPin color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.locationName' })}
                </Label>
                <Label className="label-value-information">
                  {!isEmpty(unit.locationName) ? unit.locationName : 'N/A'}
                </Label>
                <hr className={'full-width-slide-panel'} />
                <Row>
                  {unit?.latitude != null && unit?.longitude != null && (
                    <Col>
                      <UncontrolledTooltip target={'lat'}>
                        {intl.formatMessage({ id: 'common.clickCopyClipboard' })}
                      </UncontrolledTooltip>
                      <div
                        id="lat"
                        onClick={() => {
                          copyLatLong(unit?.latitude, unit?.longitude);
                        }}
                      >
                        <Label className="label-information">
                          <Icon
                            icon={'Target'}
                            color={primary}
                            size={15}
                            style={{ marginRight: '0.2rem' }}
                          />
                          {intl.formatMessage({ id: 'units.latitude' })}
                        </Label>
                        <Label className="label-value-information">
                          {unit?.latitude.toFixed(6)}
                        </Label>
                      </div>
                    </Col>
                  )}
                  {unit?.latitude != null && unit?.longitude != null && (
                    <Col className={'border-left'}>
                      <UncontrolledTooltip target={'lon'}>
                        {intl.formatMessage({ id: 'common.clickCopyClipboard' })}
                      </UncontrolledTooltip>
                      <div
                        id="lon"
                        onClick={() => {
                          copyLatLong(unit?.latitude, unit?.longitude);
                        }}
                      >
                        <Label className="label-information">
                          <Icon
                            icon={'Target'}
                            color={primary}
                            size={15}
                            style={{ marginRight: '0.2rem' }}
                          />
                          {intl.formatMessage({ id: 'units.longitude' })}
                        </Label>
                        <Label className="label-value-information">
                          {unit?.longitude.toFixed(6)}
                        </Label>
                      </div>
                    </Col>
                  )}
                  <hr className={'full-width-slide-panel'} />
                </Row>
                <Row>
                  <Col>
                    <Label className="label-information mr-2">
                      <Settings color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.status' })}
                    </Label>
                    {isEditingDowntime === true ? (
                      <Row>
                        <Col sm="6" className={'d-flex justify-content-center mt-50'}>
                          <Spinner color="primary" size="sm" />
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Badge
                          pill
                          className="mt-25"
                          style={GetMainStateStyle(GetMainStateById(unit?.mainStateId ?? -1))}
                        >
                          {unit.mainStateName}
                        </Badge>
                        {authSelectors.getAuthUserHasPermissionsAny(store, [
                          unitPermissions.downtime
                        ]) &&
                          (unit.downtimeReasonId === null ||
                            unit.downtimeReasonId === undefined) && (
                            <>
                              <UncontrolledTooltip target={'editUnitMainStateTypeButton'}>
                                {intl.formatMessage({ id: 'units.startDowntime' })}
                              </UncontrolledTooltip>
                              <Icon
                                id={'editUnitMainStateTypeButton'}
                                icon={'ArrowDown'}
                                color={primary}
                                size={17}
                                style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                                onClick={() => setShowChangeStatusPane(true)}
                              />
                            </>
                          )}
                        {authSelectors.getAuthUserHasPermissionsAny(store, [
                          unitPermissions.downtime
                        ]) &&
                          unit.downtimeReasonId !== undefined &&
                          unit.downtimeReasonId !== null && (
                            <>
                              <UncontrolledTooltip target={'restoreUnitMainStateTypeButton'}>
                                {intl.formatMessage({ id: 'units.endDowntime' })}
                              </UncontrolledTooltip>
                              <Icon
                                id={'restoreUnitMainStateTypeButton'}
                                icon={'ArrowUp'}
                                color={primary}
                                size={15}
                                style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                                onClick={() =>
                                  dispatch(unitActions.startEndDowntimeUnit(unit?.unitId))
                                }
                              />
                            </>
                          )}
                      </>
                    )}
                  </Col>
                  <Col className={'border-left'}>
                    <Label className="label-information">
                      <Icon
                        icon={'Target'}
                        color={primary}
                        size={15}
                        style={{ marginRight: '0.2rem' }}
                      />
                      {intl.formatMessage({ id: 'units.lastEvent' })}
                    </Label>
                    {unit.eventId != undefined ? (
                      isAcknowledgeUnitEvent ? (
                        <Row>
                          <Col sm="6" className={'d-flex justify-content-center mt-50'}>
                            <Spinner color="primary" size="sm" />
                          </Col>
                        </Row>
                      ) : (
                        <Media id={'lastEventBadge'} className={'d-flex align-items-center'}>
                          {unit?.intlLastEvent?.length >= 15 && (
                            <UncontrolledTooltip target={'lastEventBadge'}>
                              <FormattedMessage id={`organizations.event${unit?.eventId ?? 0}`} />
                            </UncontrolledTooltip>
                          )}
                          <Badge
                            pill
                            className="mt-25 mr-50"
                            style={{
                              color: '#' + (unit.eventTextColor || '000000'),
                              backgroundColor: '#' + unit.eventColor,
                              display: 'inline-block',
                              fontSize: '13px'
                            }}
                          >
                            {unit.eventName || unit.eventId
                              ? `${
                                  unit?.intlLastEvent.length >= 15
                                    ? unit?.intlLastEvent?.substring(0, 15) + '...'
                                    : unit.eventId != null
                                      ? unit?.intlLastEvent
                                      : ''
                                }`
                              : ''}
                          </Badge>
                          {unit.eventId !== 0 && (
                            <DefaultSimpleButton
                              id={'acknowledge'}
                              color={primary}
                              icon={'RefreshCcw'}
                              tooltipMessage={intl.formatMessage({ id: 'units.acknowledge' })}
                              handleClick={() => {
                                dispatch(unitActions.startAcknowledgeUnitEvent(unit.unitId));
                              }}
                            />
                          )}
                        </Media>
                      )
                    ) : null}
                  </Col>
                </Row>
                <hr className={'full-width-slide-panel'} />
                <Row>
                  <Col>
                    <Label className="label-information">
                      <Clock color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.gpsDate' })}
                    </Label>
                    <Label className="label-value-information">
                      {unit.gpsDate ? moment(unit.gpsDate).format('YYYY-MM-DD HH:mm') : 'N/A'}
                    </Label>
                  </Col>
                  <Col className={'border-left'}>
                    <Label className="label-information">
                      <Clock color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.lastCommunicationDate' })}
                    </Label>
                    <Label className="label-value-information">
                      {unit.lastCommunicationDate
                        ? moment(unit.lastCommunicationDate).format('YYYY-MM-DD HH:mm')
                        : 'N/A'}
                    </Label>
                  </Col>
                </Row>
                <hr className={'full-width-slide-panel'} />
                <Row>
                  <Col>
                    <Label className="label-information">
                      <Icon
                        icon={'Frontier'}
                        color={primary}
                        size={15}
                        style={{ marginRight: '0.2rem' }}
                      />
                      {intl.formatMessage({ id: 'units.odometer' })}
                    </Label>
                    <Label className="label-value-information">
                      {unit.odometerFormat || 'N/A'}{' '}
                      <ManualOdometerAdjustment
                        buttonType={ButtonTypes.Icon}
                        defaultValue={unit.odometer}
                        unitId={unit?.unitId ?? -1}
                      />
                    </Label>
                  </Col>
                  <Col className={'border-left'}>
                    <Label className="label-information">
                      <Icon
                        icon={'Frontier'}
                        color={primary}
                        size={15}
                        style={{ marginRight: '0.2rem' }}
                      />
                      {intl.formatMessage({ id: 'units.hourMeter' })}
                    </Label>
                    <Label className="label-value-information">
                      {unit.hourMeterFormat || 'N/A'}{' '}
                      <ManualHourmeterAdjustment
                        buttonType={ButtonTypes.Icon}
                        defaultValue={unit?.hourMeter}
                        unitId={unit?.unitId ?? -1}
                      />
                    </Label>
                  </Col>
                </Row>
                <hr className={'full-width-slide-panel'} />
                <Row>
                  <Col>
                    <Label className="label-information">
                      <Menu color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.privateCode' })}
                    </Label>
                    <Label className="label-value-information">
                      {!isEmpty(unit.privateCode) ? unit.privateCode : 'N/A'}
                      {userPermissions.includes('UP044') && (
                        <Icon
                          id={'editUnitPrivateCode'}
                          icon={'Edit2'}
                          color={primary}
                          size={18}
                          style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                          onClick={() => {
                            setSlidingPaneProps({
                              title: intl.formatMessage({ id: 'common.edit' }),
                              subtitle: `${intl.formatMessage({ id: 'units.unit' })}: ${title}`,
                              width: '45rem',
                              inputs: [
                                {
                                  type: 'text',
                                  name: 'privateCode',
                                  required: true,
                                  label: intl.formatMessage({ id: 'units.privateCode' })
                                }
                              ],
                              action: (values) => {
                                dispatch(
                                  unitActions.startEditingUnit({
                                    ...unit,
                                    privateCode: values.privateCode
                                  })
                                );
                              }
                            });
                            setOpenSlidingPaneForm(true);
                          }}
                        />
                      )}
                    </Label>
                  </Col>
                  <Col className={'border-left'}>
                    <Label className="label-information">
                      <Menu color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                      {intl.formatMessage({ id: 'units.privateCode' }) + ' 2'}
                    </Label>
                    <Label className="label-value-information">
                      {!isEmpty(unit.privateCode2) ? unit.privateCode2 : 'N/A'}
                      {userPermissions.includes('UP045') && (
                        <Icon
                          id={'editUnitPrivateCode2'}
                          icon={'Edit2'}
                          color={primary}
                          size={18}
                          style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                          onClick={() => {
                            setSlidingPaneProps({
                              title: intl.formatMessage({ id: 'common.edit' }),
                              subtitle: `${intl.formatMessage({ id: 'units.unit' })}: ${title}`,
                              width: '45rem',
                              inputs: [
                                {
                                  type: 'text',
                                  name: 'privateCode2',
                                  required: true,
                                  label: intl.formatMessage({ id: 'units.privateCode' }) + ' 2'
                                }
                              ],
                              action: (values) => {
                                dispatch(
                                  unitActions.startEditingUnit({
                                    ...unit,
                                    privateCode2: values.privateCode2
                                  })
                                );
                              }
                            });
                            setOpenSlidingPaneForm(true);
                          }}
                        />
                      )}
                    </Label>
                  </Col>
                </Row>
                <hr className={'full-width-slide-panel'} />
                <Row>
                  <Col>
                    <Label className="label-information">
                      <Icon
                        icon={'Speedometer'}
                        color={primary}
                        size={17}
                        style={{ marginRight: '0.2rem' }}
                      />
                      {intl.formatMessage({ id: 'units.speed' })}
                    </Label>
                    <Label className="label-value-information">{unit.speedFormat || 'N/A'}</Label>
                  </Col>
                  {availableIndicators
                    .filter((indicator) => !indicator.useInAppCollapse)
                    .map((indicator, i) => (
                      <Fragment key={i}>
                        {i % 2 !== 0 && <hr className={'full-width-slide-panel'} />}
                        <Col className={i % 2 === 0 ? 'border-left' : ''}>
                          <Label className="label-information">
                            <Terminal color={primary} size={17} style={{ marginRight: '0.2rem' }} />
                            {intl.formatMessage({ id: indicator.title })}
                          </Label>
                          <Label className="label-value-information">
                            {indicator.currentStatus +
                              ' ' +
                              ((indicator.currentStatus != '--' ? indicator.metric : '') || '')}
                          </Label>
                        </Col>
                      </Fragment>
                    ))}
                </Row>
                <hr className={'full-width-slide-panel'} />
                {(unit?.deviceActions
                  ?.filter((action) => action?.deviceActionId)
                  ?.filter((action) =>
                    authSelectors.getAuthUserHasPermissionsAny(store, [
                      unitPermissions[`deviceAction${action.deviceActionId}`]
                    ])
                  )?.length ?? 0) > 0 && (
                  <>
                    <Label className="label-information">
                      <Icon
                        icon={'Lightning'}
                        color={primary}
                        size={22}
                        style={{ marginRight: '0.2rem' }}
                      />
                      {intl.formatMessage({ id: 'units.actions' })}
                    </Label>
                    <Toolbar
                      position={'left'}
                      buttons={
                        unit?.deviceActions
                          ?.filter((action) => action?.deviceActionId)
                          ?.map((action, i) => (
                            <DefaultButton
                              className={'mt-50'}
                              id={'ActionButton-' + i}
                              icon={getUnitActionIcon(action.deviceActionId)}
                              permissions={[
                                unitPermissions[`deviceAction${action.deviceActionId}`]
                              ]}
                              handleClick={() => doAction(unit, action)}
                              tooltipMessage={intl.formatMessage({
                                id: 'units.deviceActionId.' + action.deviceActionId
                              })}
                              styles={{
                                backgroundColor: action.deviceActionColor,
                                color: action.deviceActionFontColor
                              }}
                              color={
                                action.deviceActionColor
                                  ? `${action.deviceActionColor}`
                                  : 'secondary'
                              }
                            />
                          )) ?? []
                      }
                    />
                  </>
                )}
                          </div>
                        )
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 3)?.length ?? 0) > 0 && {
                        tabId: 2,
                        component: (
                          <div className={'pt-1'}>
                            <UnitTemperature
                              unit={unit}
                              sensors={unit.sensors?.filter((s) => s.measureTypeId === 3)}
                            />
                          </div>
                        )
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 8)?.length ?? 0) > 0 && {
                        tabId: 3,
                        component: (
                          <div className={'pt-1'}>
                            <UnitFuel
                              unit={unit}
                              sensors={unit.sensors?.filter((s) => s?.measureTypeId === 8)}
                              authSystems={authSystems}
                            />
                          </div>
                        )
                      },
                      (unit?.deviceMetrics?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 16)?.length ?? 0) > 0 && {
                        tabId: 4,
                        component: (
                          <div className={'pt-1'}>
                            <Row>
                              {unit?.deviceMetrics
                                ?.filter((metric) => metric?.measureTypeId && metric.measureTypeId === 16)
                                ?.map((metric, i) => (
                                  <Fragment key={i}>
                                    {i % 2 === 0 && i !== 0 && (
                                      <hr className={'full-width-slide-panel'} />
                                    )}
                                    <Col className={i % 2 !== 0 ? 'border-left' : ''}>
                                      <Label className="label-information">
                                        <Icon
                                          icon={'GasStation'}
                                          color={primary}
                                          size={16}
                                          style={{ marginRight: '0.2rem' }}
                                        />
                                        {metric.metricDescription}
                                      </Label>
                                      <Label className="label-value-information">{`${metric.numberValue} ${metric.measurementUnitName}`}</Label>
                                    </Col>
                                  </Fragment>
                                ))}
                            </Row>
                          </div>
                        )
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'SIM')?.length ?? 0) > 0 && {
                        tabId: 5,
                        component: (
                          <div className={'pt-1'}>
                            <Row>
                              {unitIndicators
                                .filter((indicator) => indicator.informationType === 'SIM')
                                .map((indicator, i) => (
                                  <Fragment key={i}>
                                    {i % 2 === 0 && i !== 0 && (
                                      <hr className={'full-width-slide-panel'} />
                                    )}
                                    <Col className={i % 2 !== 0 ? 'border-left' : ''}>
                                      <Label className="label-information">
                                        <Icon
                                          icon={'Phone'}
                                          color={primary}
                                          size={16}
                                          style={{ marginRight: '0.2rem' }}
                                        />
                                        {intl.formatMessage({ id: indicator.title })}
                                      </Label>
                                      <Label className={'label-value-information'}>
                                        {indicator.currentStatus +
                                          ' ' +
                                          ((indicator.currentStatus != '--' ? indicator.metric : '') || '')}
                                      </Label>
                                    </Col>
                                  </Fragment>
                                ))}
                            </Row>
                          </div>
                        )
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'DEVICE')?.length ?? 0) > 0 && {
                        tabId: 6,
                        component: (
                          <div className={'pt-1'}>
                            <Row>
                              {unitIndicators
                                .filter((indicator) => indicator.informationType === 'DEVICE')
                                .map((indicator, i) => (
                                  <Fragment key={i}>
                                    {i % 2 === 0 && i !== 0 && (
                                      <hr className={'full-width-slide-panel'} />
                                    )}
                                    <Col className={i % 2 !== 0 ? 'border-left' : ''}>
                                      <Label className="label-information">
                                        <Icon
                                          icon={'noun_GPS_3452904'}
                                          color={primary}
                                          size={16}
                                          style={{ marginRight: '0.2rem' }}
                                        />
                                        {intl.formatMessage({ id: indicator.title })}
                                      </Label>
                                      <Label className={'label-value-information'}>
                                        {indicator.currentStatus +
                                          ' ' +
                                          ((indicator.currentStatus != '--' ? indicator.metric : '') || '')}
                                      </Label>
                                    </Col>
                                  </Fragment>
                                ))}
                            </Row>
                          </div>
                        )
                      },
                      (unitIndicators.filter((indicator) => indicator.informationType === 'VEHICLE')?.length ?? 0) > 0 && {
                        tabId: 7,
                        component: (
                          <div className={'pt-1'}>
                            <Row>
                              {unitIndicators
                                .filter((indicator) => indicator.informationType === 'VEHICLE')
                                .map((indicator, i) => (
                                  <Fragment key={i}>
                                    {i % 2 === 0 && i !== 0 && (
                                      <hr className={'full-width-slide-panel'} />
                                    )}
                                    <Col className={i % 2 !== 0 ? 'border-left' : ''}>
                                      <Label className="label-information">
                                        <Icon
                                          icon={'noun_Wheel_4039720'}
                                          color={primary}
                                          size={16}
                                          style={{ marginRight: '0.2rem' }}
                                        />
                                        {intl.formatMessage({ id: indicator.title })}
                                      </Label>
                                      <Label className={'label-value-information'}>
                                        {indicator.currentStatus +
                                          ' ' +
                                          ((indicator.currentStatus != '--' ? indicator.metric : '') || '')}
                                      </Label>
                                    </Col>
                                  </Fragment>
                                ))}
                            </Row>
                          </div>
                        )
                      },
                      (unitAssetInformation?.length ?? 0) > 0 && {
                        tabId: 8,
                        component: (
                          <div className={'pt-1'}>
                            {unitAssetInformation.map((content, rowIndex) => (
                              <>
                                <h4>{content?.assetIdentifier}</h4>
                                <hr className={'full-width-slide-panel'} />
                                <Row key={rowIndex}>
                                  {content.assetData.map((indicator, i) => (
                                    <Fragment key={i}>
                                      {i % 2 === 0 && i !== 0 && (
                                        <hr className={'full-width-slide-panel'} />
                                      )}
                                      <Col className={i % 2 !== 0 ? 'border-left' : ''}>
                                        <Label className="label-information">
                                          <Icon
                                            icon={'Alert-76'}
                                            color={primary}
                                            size={16}
                                            style={{ marginRight: '0.2rem' }}
                                          />
                                          {intl.formatMessage({ id: indicator.title })}
                                        </Label>
                                        <Label className={'label-value-information'}>
                                          {indicator.currentStatus +
                                            ' ' +
                                            (indicator.currentStatus !== '--' ? indicator.metric : '')}
                                        </Label>
                                      </Col>
                                    </Fragment>
                                  ))}
                                </Row>
                                {unitAssetInformation.length !== 1 &&
                                  rowIndex !== unitAssetInformation.length - 1 && (
                                    <hr className={'full-width-slide-panel'} />
                                  )}
                              </>
                            ))}
                          </div>
                        )
                      },
                      unit?.organizationId && {
                        tabId: 9,
                        component: (
                          <div className={'pt-1'}>
                            <Row>
                              <Col sm="12">
                                <Label className="label-information">
                                  <Icon
                                    icon={'Operator'}
                                    color={primary}
                                    size={16}
                                    style={{ marginRight: '0.2rem' }}
                                  />
                                  {intl.formatMessage({ id: 'operators.operator' })}
                                </Label>
                                <Label className={'label-value-information'}>
                                  {unit?.operatorName || 'N/A'}
                                </Label>
                              </Col>
                            </Row>
                            <hr className={'full-width-slide-panel'} />
                            <Row>
                              <Col sm="12">
                                <Label className="label-information">
                                  <Icon
                                    icon={'Organization'}
                                    color={primary}
                                    size={16}
                                    style={{ marginRight: '0.2rem' }}
                                  />
                                  {intl.formatMessage({ id: 'organizations.organization' })}
                                </Label>
                                <Label className={'label-value-information'}>
                                  {unit?.organizationName || 'N/A'}
                                </Label>
                              </Col>
                            </Row>
                            <hr className={'full-width-slide-panel'} />
                            <Row>
                              <Col sm="12">
                                <Label className="label-information">
                                  <Icon
                                    icon={'Division'}
                                    color={primary}
                                    size={16}
                                    style={{ marginRight: '0.2rem' }}
                                  />
                                  {intl.formatMessage({ id: 'divisions.division' })}
                                </Label>
                                <Label className={'label-value-information'}>
                                  {unit?.divisionName || 'N/A'}
                                </Label>
                              </Col>
                            </Row>
                            <hr className={'full-width-slide-panel'} />
                            <Row>
                              <Col sm="12">
                                <Label className="label-information">
                                  <Icon
                                    icon={'Subdivision'}
                                    color={primary}
                                    size={16}
                                    style={{ marginRight: '0.2rem' }}
                                  />
                                  {intl.formatMessage({ id: 'subdivisions.subdivision' })}
                                </Label>
                                <Label className={'label-value-information'}>
                                  {unit?.subdivisionName || 'N/A'}
                                </Label>
                              </Col>
                            </Row>
                          </div>
                        )
                      }
        ].filter((content) => content)}
        />
        </div>
        <hr className={'full-width-slide-panel'} />
      </>
            )}
          </>
        )}
      </SlidingPane>
      {isLightboxOpen && (
        <Lightbox
          discourageDownloads={false}
          reactModalStyle={{ overlay: { zIndex: 20000 } }}
          imageTitle={unit?.driverName}
          imageCaption={
            <>
              <div>{`${intl.formatMessage({ id: 'units.phone' })}: ${
                unit?.driverPhoneNumber ?? 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'units.bloodType' })}: ${
                unit?.driverBloodType ?? 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'units.licenseNumber' })}: ${
                unit?.driverLicenseNumber ?? 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'units.licenseType' })}: ${
                unit?.driverLicenseType ?? 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'units.licenseExpireDate' })}: ${
                unit?.driverLicenseExpireDate
                  ? moment(unit.driverLicenseExpireDate).format('YYYY-MM-DD')
                  : 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'units.useGlasses' })}: ${intl.formatMessage({
                id: unit?.driverUseGlasses ? 'common.yes' : 'common.no'
              })}`}</div>
              <div>{`${intl.formatMessage({
                id: 'units.bloodSugarProblems'
              })}: ${intl.formatMessage({
                id: unit?.driverBloodSugarProblems ? 'common.yes' : 'common.no'
              })}`}</div>
              <div>{`${intl.formatMessage({ id: 'drivers.securityQuestion' })}: ${
                unit?.driverSecurityQuestion ?? 'N/A'
              }`}</div>
              <div>{`${intl.formatMessage({ id: 'drivers.securityAnswer' })}: ${
                unit?.driverSecurityAnswer ?? 'N/A'
              }`}</div>
            </>
          }
          mainSrc={unit?.driverPhoto ?? ''}
          onCloseRequest={() => setIsLightboxOpen(false)}
        />
      )}
      <SlidingPaneForm
        confirmText={intl.formatMessage({ id: 'common.confirm' })}
        isOpenSlidingPane={isOpenSlidingPaneForm}
        closeSlidingPaneForm={() => setOpenSlidingPaneForm(false)}
        {...slidingPaneProps}
      />{' '}
      <SlidingPaneUnitImages
        closeSlidingPane={() => {
          setShowUnitImagesSlidingPane(false);
        }}
        isSlidingPaneOpen={showUnitImagesSlidingPane}
        title={unit?.unitName}
        unit={unit}
        addImageInitial={showAddImageSlidingPane}
      />
      <SlidingPaneUnitHistoricalPositionsReport
        closeSlidingPane={() => {
          setShowHistPositionsReportSlidingPane(false);
          if (setIsTrajectoryDisable) setIsTrajectoryDisable(false);
        }}
        setMapPositionToPositionsBounds={setMapPositionToPositionsBounds}
        changeSetMapPositionToUnitsBounds={changeSetMapPositionToUnitsBounds}
        isSlidingPaneOpen={showHistPositionsReportSlidingPane}
        showHistoricalPositions={showHistoricalPositions}
        title={intl.formatMessage({ id: 'units.historicalPositionsReport' })}
        selectedUnit={selectedUnit}
        selectedUnitRef={selectedUnitRef}
        setSelectedUnit={setSelectedUnit}
        subtitle={unit?.unitName ?? ''}
        unit={unit}
      />
      <SlidingPaneShareUnitLocation
        closeSlidingPane={() => {
          setShowShareUnitLocationSlidingPane(false);
        }}
        isSlidingPaneOpen={showShareUnitLocationSlidingPane}
        unit={unit}
      />
      <SlidingPaneStartUnitDowntime
        closeSlidingPane={() => {
          setShowChangeStatusPane(false);
        }}
        isSlidingPaneOpen={showChangeStatusSlidingPane}
        unit={unit}
        organization={{
          organizationId: unit?.organizationId,
          organizationName: unit?.organizationName
        }}
        width="45rem"
      />
      <SlidingPaneDowntimeBinnacle
        isOpenSlidingPane={downtimeBinnacleSlideOpen}
        closeSlidingPaneDowntimeBinnacle={() => {
          openDowntimeBinnacleSlide(false);
        }}
        unitId={unit?.unitId}
        unitName={unit?.unitName}
      />
      <SlidingPanePreviewDriverImages
        driver={
          unit !== undefined && unit !== null
            ? { driverId: unit?.driverId, driverName: unit?.driverName }
            : undefined
        }
        isOpenSlidingPane={previewDriverImagesSlideOpen}
        closeSlidingPanePreviewDriverImages={() => {
          openPreviewDriverImagesSlide(false);
        }}
      />
      <SlidingPaneEntityTimelineBinnacle
        entityName={unit?.unitName}
        entityTypeId={entityTypes?.ENTITY_UNITS}
        entityId={unit?.unitId}
        isOpenSlidingPane={entityBinnacleSlideOpen}
        closeSlidingPaneEntityBinnacle={() => {
          openEntityBinnacleSlide(false);
        }}
        width={'45rem'}
      />
      {showSendScriptsSlidingPane && (
        <SlidingPaneUnitSendScripts
          unitId={unitId}
          unitName={unit ? unit.unitName : ''}
          isOpenSlidingPane={showSendScriptsSlidingPane}
          closeSlidingPaneSendScripts={() => setShowSendScriptsSlidingPane(false)}
        />
      )}
      {openSpecialFunctionsSlidingPane && (
        <SlidingPaneUnitSpecialFunctions
          unitId={unitId}
          unitName={unit ? unit.unitName : ''}
          isOpenSlidingPane={openSpecialFunctionsSlidingPane}
          closeSlidingPane={() => setOpenSpecialFunctionsSlidingPane(false)}
          width={'45rem'}
        />
      )}
      <Modal isOpen={isOpenModal} toggle={closeModal} centered>
        <ModalHeader toggle={closeModal}>{appMapEmbedLink.title}</ModalHeader>
        <div style={{ height: '400px', overflow: 'hidden', position: 'relative' }}>
          {appMapEmbedLink.link.includes('waze') ? (
            <a
              href={appMapEmbedLink.link}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'inline-block',
                width: '100%',
                height: '8%',
                zIndex: 5
              }}
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          ) : null}
          <iframe
            src={appMapEmbedLink.link}
            width="100%"
            height="400px"
            allowFullScreen
            title="Waze Map"
            style={{ border: 'none' }}
          />
        </div>
        <ModalFooter className="justify-content-end">
          <Button
            className="m-0"
            color="secondary"
            id="shareLocationLinkViaWhatsAppButton"
            onClick={() => window.open(appMapEmbedLink?.shareWhatsAppLink, '_blank')}
          >
            <Icon className="mr-1" icon={'whatsapp'} size={18} />
            {intl.formatMessage({ id: 'common.share' })}
          </Button>
        </ModalFooter>
      </Modal>
      {/* Video Player Sliding Pane */}
      {showVideoPlayerSlidingPane && (
        <SlidingPaneVideoPlayer
          isOpenSlidingPane={showVideoPlayerSlidingPane}
          closeSlidingPane={() => setShowVideoPlayerSlidingPane(false)}
          unit={unit}
          width={'45rem'}
        />
      )}
    </>
  );
}
